module.exports = __webpack_public_path__ + "img/48bef76.jpg";